var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedispatch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 458,
    height: 363,
    viewBox: "0 0 458 363",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Redispatch2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FloorNeu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M237.406 362.107L0.815735 228.947L0.855735 209.687L31.0057 196.697L237.396 306.697L267.736 341.387L237.396 362.097L237.406 362.107Z",
    fill: "#64615F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M237.406 362.657L0.815735 228.977V226.437L237.406 360.267V362.657V362.657Z",
    fill: "#826956"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M457.366 242.707L237.406 362.657V320.707L426.496 210.127L457.346 223.117V242.707H457.366Z",
    fill: "#3C3839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.865723 209.687L237.406 343.867L457.356 223.117L220.626 89.447L0.865723 209.687Z",
    fill: "#65813F"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Schlot-Schatten",
    d: "M243.418 230.659C243.418 244.098 220.996 254.993 193.338 254.993C165.68 254.993 143.258 244.098 143.258 230.659C143.258 217.221 165.68 206.326 193.338 206.326C220.996 206.326 243.418 217.221 243.418 230.659Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Windrad-Schatten",
    d: "M136.957 198.074C136.957 202.589 129.423 206.25 120.129 206.25C110.835 206.25 103.301 202.589 103.301 198.074C103.301 193.558 110.835 189.897 120.129 189.897C129.423 189.897 136.957 193.558 136.957 198.074Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Netz"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KabelSchlot"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Kabel",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.508 189.44L207.824 228.112L205.371 223.755L274.055 185.083L276.508 189.44Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "REdot2-Container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "REdot2_1-Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "REdot2_1",
    d: "M227.889 217.644C227.889 221.13 225.063 223.956 221.577 223.956C218.091 223.956 215.265 221.13 215.265 217.644C215.265 214.158 218.091 211.332 221.577 211.332C225.063 211.332 227.889 214.158 227.889 217.644Z",
    fill: "#B4005F"
  })), /*#__PURE__*/React.createElement("path", {
    id: "REdot2",
    d: "M227.889 217.644C227.889 221.13 225.063 223.956 221.577 223.956C218.091 223.956 215.265 221.13 215.265 217.644C215.265 214.158 218.091 211.332 221.577 211.332C225.063 211.332 227.889 214.158 227.889 217.644Z",
    fill: "#B4005F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "KabelWindrad"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Kabel_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.1 147.852L272.197 185.794L269.736 190.146L205.04 153.562L196.195 158.322L196.181 158.329L124.619 197.417L122.223 193.029L193.805 153.93L205.1 147.852Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "REdot3-Container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "REdot3_1-Container"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "REdot3_1",
    cx: 125.919,
    cy: 193.775,
    r: 6.31184,
    fill: "#B4005F"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "REdot3",
    cx: 125.919,
    cy: 193.775,
    r: 6.31184,
    fill: "#B4005F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "KabelPV"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Kabel_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.171 234.774L271.99 191.692L274.451 187.34L358.47 234.853L272.868 281.524L270.475 277.134L348.171 234.774Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "REdot1-Container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "REdot1_1-Container"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "REdot1_1",
    cx: 287.013,
    cy: 269.884,
    r: 6.31184,
    fill: "#B4005F"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "REdot1",
    cx: 287.013,
    cy: 269.884,
    r: 6.31184,
    fill: "#B4005F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Geb\xC3\xA4ude"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Masten"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Kabel_4",
    d: "M237.577 114.664C237.577 114.664 177.583 100.195 168.652 73.8927",
    stroke: "url(#paint0_linear_1736_803)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mast1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M251.186 186.915L270.512 198.074L289.839 186.915L270.512 175.757L251.186 186.915Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.752 129.44L322.384 137.075L312.473 137.511H303.815L310.306 144.384L257.818 173.955L258.281 188.213L270.291 195.789L327.262 163.184L334.021 170.866L340.516 157.061L341.581 154.99L348.335 151.124L347.894 136.795L335.752 129.44ZM338.76 153.321L344.5 150.04L337.783 145.713L337.802 146.197L341.987 148.673L337.991 150.903L338.072 152.913L338.76 153.321ZM315.58 146.833L312.473 145.262L308.333 148.203L311.45 150.193L315.58 146.833ZM308.992 151.564L307.174 150.393L307.353 158.569L313.422 154.996L308.287 151.957L308.992 151.564ZM317.79 157.58L317.938 165.283L324.488 161.543L317.79 157.58ZM327.351 140.014L333.342 143.558L334.021 143.17L327.304 138.843L327.351 140.014ZM275.746 189.431L275.426 181.448L282.143 185.774L275.746 189.431ZM285.275 175.879L285.595 183.862L291.992 180.206L285.275 175.879ZM282.289 163.183L282.643 171.165L275.907 166.866L282.289 163.183ZM305.087 158.348L304.732 150.366L298.351 154.05L305.087 158.348ZM335.075 140.979L334.721 132.997L328.339 136.681L335.075 140.979ZM272.463 168.793L272.818 176.775L266.082 172.477L272.463 168.793ZM293.147 178.004L292.792 170.022L286.213 173.855L293.147 178.004ZM305.269 162.822L305.467 170.866L298.689 166.655L305.269 162.822ZM315.58 165.105L315.382 157.061L308.802 160.894L315.58 165.105ZM283.064 175.594L283.419 183.576L276.568 179.292L283.064 175.594ZM307.593 163.005L307.913 170.988L314.31 167.331L307.593 163.005ZM297.098 156.252L297.418 164.235L303.815 160.578L297.098 156.252ZM284.765 163.231L284.945 171.319L291.482 167.557L284.765 163.231ZM275.411 176.775L275.091 168.792L281.808 173.119L275.411 176.775ZM345.627 147.816L338.873 143.598L345.344 139.971L345.627 147.816ZM337.637 141.119L337.264 133.228L343.996 137.511L337.637 141.119ZM295.526 178.18L295.29 168.636L296.378 168.007L304.318 173.125L295.526 178.18ZM294.952 165.676L294.704 156.132L285.919 161.197L293.864 166.306L294.952 165.676Z",
    fill: "url(#paint1_linear_1736_803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Kabel_5",
    d: "M291.658 78.5013C291.658 78.5013 231.664 64.0329 222.733 37.7303",
    stroke: "url(#paint2_linear_1736_803)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Kabel_6",
    d: "M360.509 109.112C360.509 109.112 325.388 100.642 304.889 84.8822",
    stroke: "url(#paint3_linear_1736_803)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mast"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M255.036 178.181L270.284 169.376L285.534 178.181L270.284 186.984L255.036 178.181Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M255.036 178.181V186.984L270.284 195.789V186.984L255.036 178.181Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M270.284 195.789L285.534 186.984V178.181L270.284 186.984V195.789Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M270.284 157.378V155.42L282.141 162.352V164.224L270.284 157.378Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M270.284 155.42L271.981 154.44L282.141 160.58V162.352L270.284 155.42Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M268.589 170.353V121.93L270.284 122.91V171.332L268.589 170.353Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M271.981 170.353V121.93L270.284 122.91V171.332L271.981 170.353Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M270.284 142.233V140.275L282.141 147.124V149.078L270.284 142.233Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M270.284 140.275L271.981 139.296L282.141 145.435V147.206L270.284 140.275Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M270.285 157.378V155.42L258.429 162.352V164.224L270.285 157.378Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M270.285 155.42L268.589 154.44L258.429 160.58V162.352L270.285 155.42Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M270.285 142.233V140.275L258.429 147.206V149.078L270.285 142.233Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M270.285 140.275L268.589 139.296L258.429 145.435V147.206L270.285 140.275Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M255.036 178.181V129.76L256.732 130.738V179.16L255.036 178.181Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M258.429 178.181V129.76L256.732 130.738V179.16L258.429 178.181Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M268.589 186.005V137.584L270.284 138.563V186.984L268.589 186.005Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M271.981 186.005L271.96 135.631L270.264 136.61L270.284 186.984L271.981 186.005Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M282.141 178.181V129.76L283.837 130.738V179.16L282.141 178.181Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M285.534 178.181L285.511 127.845L283.814 128.825L283.837 179.16L285.534 178.181Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M270.284 107.256V105.299L282.141 112.148V114.102L270.284 107.256Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M270.284 105.299L271.981 104.319L282.141 110.458V112.23L270.284 105.299Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M270.284 122.984V121.025L282.141 127.874V129.829L270.284 122.984Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M270.284 121.025L271.981 120.046L282.141 126.185V127.957L270.284 121.025Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M256.732 165.207V163.248L268.589 170.18V172.053L256.732 165.207Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M256.732 163.248L258.429 162.269L268.589 168.408V170.18L256.732 163.248Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M256.732 150.062V148.103L268.589 155.035V156.908L256.732 150.062Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M256.732 148.103L258.429 147.124L268.589 153.263V155.035L256.732 148.103Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M283.837 165.289V163.331L271.981 170.263V172.135L283.837 165.289Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M283.837 163.331L282.141 162.352L271.981 168.491V170.262L283.837 163.331Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M283.837 150.144V148.185L271.981 155.117V156.99L283.837 150.144Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M283.837 148.185L282.141 147.206L271.981 153.346V155.117L283.837 148.185Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M283.837 130.766L283.813 128.795L270.305 136.61V138.552L283.837 130.766Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M285.533 127.801L283.837 126.822L268.609 135.631L270.305 136.611L285.533 127.801Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M270.285 122.944L270.245 120.967L256.732 128.785L256.731 130.738L270.285 122.944Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M271.96 119.975L270.264 118.995L255.036 127.806L256.732 128.785L271.96 119.975Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M255.045 129.828V112.138L256.741 113.118V130.808L255.045 129.828Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M258.437 127.823V112.138L256.741 113.118V128.802L258.437 127.823Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M268.531 120L268.536 104.277L270.251 105.268V120.993L268.531 120Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M271.947 120.013V104.289L270.251 105.268V120.993L271.947 120.013Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M271.947 106.224V104.287L256.741 113.118V115.031L271.947 106.224Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M271.947 104.287L270.225 103.293L255.045 112.139L256.741 113.118L271.947 104.287Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M268.608 135.666V119.981L270.304 120.96V136.645L268.608 135.666Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M272 135.666V119.981L270.304 120.96V136.645L272 135.666Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M282.094 127.843L282.099 112.12L283.814 113.111V128.836L282.094 127.843Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M285.51 127.857V112.131L283.814 113.111V128.836L285.51 127.857Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M285.534 114.1L285.51 112.129L270.304 120.96V122.873L285.534 114.1Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M285.509 112.129L283.787 111.136L268.608 119.981L270.304 120.96L285.509 112.129Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M256.732 130.812V128.853L268.589 135.785V137.658L256.732 130.812Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M256.732 128.853L258.429 127.874L268.589 134.014V135.785L256.732 128.853Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M256.732 115.085V113.127L268.589 120.058V121.93L256.732 115.085Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M256.732 113.127L258.429 112.148L268.589 118.287V120.058L256.732 113.127Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M255.045 112.131V96.4465L256.741 97.4258V113.111L255.045 112.131Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M258.437 112.131V96.4465L256.741 97.4258V113.111L258.437 112.131Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M268.531 104.308L268.536 88.5848L270.251 89.5762V105.301L268.531 104.308Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M271.947 104.322V88.5972L270.251 89.5765V105.301L271.947 104.322Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M303.208 72.2863V70.35L224.006 116.389V118.302L303.208 72.2863Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M271.947 88.5952L270.225 87.6017L255.045 96.4467L256.741 97.426L271.947 88.5952Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M303.216 70.3307L301.494 69.3372L222.318 115.394L224.014 116.373L303.216 70.3307Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M270.251 91.5349V89.5763L282.107 96.4252V98.3807L270.251 91.5349Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M270.251 89.5765L271.947 88.5972L283.787 95.4441L282.107 96.5086L270.251 89.5765Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M303.329 72.1927L303.303 70.2219L271.878 72.9457V74.8586L303.329 72.1927Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M303.302 70.2201L301.364 69.3585L270.181 71.9686L271.877 72.9468L303.302 70.2201Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M256.741 99.3845V97.4259L268.54 104.257L266.989 105.156L256.741 99.3845Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M256.741 97.4259L258.355 96.475L270.225 103.347L268.655 104.323L256.741 97.4259Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M254.978 96.5208V80.836L256.674 81.8153V97.5001L254.978 96.5208Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M258.371 96.5208V80.836L256.674 81.8153V97.5001L258.371 96.5208Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M268.464 88.6976L268.469 72.9752L270.184 73.9657V89.6911L268.464 88.6976Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M271.88 88.7118V72.9864L270.184 73.9657V89.6911L271.88 88.7118Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M271.88 74.9214V72.9841L256.674 81.815V83.7279L271.88 74.9214Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M271.88 72.9841L270.158 71.9906L254.978 80.8357L256.674 81.815L271.88 72.9841Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M280.557 85.6155V83.6569L292.47 90.5535L291.004 91.3228L280.557 85.6155Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M280.557 83.6569L282.17 82.706L294.04 89.5783L292.47 90.5535L280.557 83.6569Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M291.584 78.9848V77.0263L303.498 83.9229L302.371 85.0432L291.584 78.9848Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M291.584 77.0262L293.197 76.0754L305.068 82.9476L303.498 83.9229L291.584 77.0262Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M301.606 73.092V71.1334L313.52 78.029L313.481 80.0018L301.606 73.092Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M301.606 71.1334L303.219 70.1825L315.09 77.0548L313.52 78.029L301.606 71.1334Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "VECTOR",
    d: "M268.608 119.974V104.289L270.304 105.268V120.953L268.608 119.974Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Kabel_7",
    d: "M301.606 143.598C301.606 143.598 266.999 135.251 246.44 119.713",
    stroke: "url(#paint4_linear_1736_803)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M272 119.974V104.289L270.304 105.268V120.953L272 119.974Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M282.094 112.151L282.099 96.4282L283.814 97.4186V113.143L282.094 112.151Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M285.51 112.165V96.4396L283.814 97.4189V113.143L285.51 112.165Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M316.796 80.1619L316.77 78.1922L237.569 124.231V126.144L316.796 80.1619Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M316.77 78.1893L314.831 77.3278L235.871 123.253L237.567 124.232L316.77 78.1893Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M316.796 80.1619L316.771 78.1922L285.345 80.9159V82.8288L316.796 80.1619Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M316.77 78.1893L315.09 77.0548L283.648 79.9378L285.344 80.9171L316.77 78.1893Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M270.251 76.0581V74.0995L282.107 80.9485V82.903L270.251 76.0581Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M270.251 74.0997L271.947 73.1204L283.787 79.9673L282.107 81.0308L270.251 74.0997Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M268.541 104.363V88.6782L270.237 89.6575V105.342L268.541 104.363Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M271.934 104.363V88.6782L270.237 89.6575V105.342L271.934 104.363Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M282.027 96.54L282.032 80.8176L283.747 81.8081V97.5335L282.027 96.54Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M285.443 96.5542V80.8288L283.747 81.8081V97.5335L285.443 96.5542Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M285.467 82.7973L285.443 80.8276L270.237 89.6574V91.5703L285.467 82.7973Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M285.443 80.8276L283.721 79.8331L268.541 88.6781L270.237 89.6574L285.443 80.8276Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M256.675 83.7524V81.7938L268.542 88.6569V90.652L256.675 83.7524Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M256.675 81.7938L258.288 80.8429L270.159 87.7152L268.589 88.6904L256.675 81.7938Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M254.979 80.8572V65.1724L256.675 66.1517V81.8365L254.979 80.8572Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M258.371 80.8572V65.1724L256.675 66.1517V81.8365L258.371 80.8572Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M268.465 73.034L268.47 57.3117L270.185 58.3021V74.0275L268.465 73.034Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M271.881 73.0482V57.3228L270.185 58.3021V74.0275L271.881 73.0482Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M271.881 59.2581V57.3218L256.675 66.1516V68.0645L271.881 59.2581Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M271.881 57.3218L270.159 56.3273L254.979 65.1724L256.675 66.1517L271.881 57.3218Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M270.122 60.2556V58.297L281.979 65.1459V67.1004L270.122 60.2556Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M270.122 58.2969L271.818 57.3176L283.659 64.1645L281.979 65.228L270.122 58.2969Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M268.542 88.6997V73.0149L270.238 73.9941V89.679L268.542 88.6997Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M271.933 88.6997V73.0149L270.238 73.9941V89.679L271.933 88.6997Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M282.028 80.8765L282.033 65.1541L283.748 66.1446V81.87L282.028 80.8765Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M285.444 80.8907V65.1653L283.748 66.1445V81.8699L285.444 80.8907Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M285.468 67.134L285.443 65.1643L270.238 73.9941V75.907L285.468 67.134Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M285.444 65.1643L283.721 64.1698L268.542 73.0148L270.238 73.9941L285.444 65.1643Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M256.644 68.1042V66.1466L268.512 73.0097V75.0048L256.644 68.1042Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M256.644 66.1466L258.258 65.1957L270.128 72.067L268.558 73.0422L256.644 66.1466Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M222.313 117.328L222.319 115.399L224.015 116.378L224.009 118.307L222.313 117.328Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M235.868 125.184L235.873 123.255L237.569 124.234L237.564 126.163L235.868 125.184Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M256.702 81.8495L254.98 80.856L222.318 115.394L224.014 116.373L256.702 81.8495Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M256.663 83.7989V81.8627L224.006 116.388V118.301L256.663 83.7989Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M245.605 105.785V103.827L257.518 110.723L256.052 111.493L245.605 105.785Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M245.605 103.827L247.218 102.876L259.088 109.747L257.518 110.723L245.605 103.827Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M233.128 113.006V111.048L245.042 117.944L243.915 119.065L233.128 113.006Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M233.128 111.048L234.741 110.097L246.612 116.969L245.042 117.944L233.128 111.048Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M223.993 118.274V116.315L235.907 123.212L235.869 125.184L223.993 118.274Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M223.993 116.315L225.607 115.365L237.477 122.237L235.907 123.212L223.993 116.315Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M270.272 89.7205L268.55 88.727L235.888 123.265L237.584 124.244L270.272 89.7205Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M270.233 91.6699V89.7326L237.577 124.259V126.172L270.233 91.6699Z",
    fill: "#747773"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Windrad"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Foot"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M115.11 192.919C112.321 192.919 109.532 193.533 107.404 194.761C105.276 195.99 104.212 197.599 104.212 199.21C104.212 200.821 105.276 202.43 107.404 203.659C109.532 204.887 112.321 205.503 115.11 205.503C117.899 205.503 120.688 204.887 122.816 203.659C124.944 202.43 126.008 200.821 126.008 199.21C126.008 197.599 124.944 195.99 122.816 194.761C120.687 193.533 117.899 192.918 115.11 192.919Z",
    fill: "#B5B3AB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M122.816 191.201C120.687 189.973 117.899 189.359 115.11 189.359C112.321 189.359 109.532 189.973 107.404 191.201C105.276 192.43 104.212 194.04 104.212 195.65V198.332C104.212 199.943 105.276 201.553 107.404 202.781C109.532 204.01 112.321 204.625 115.11 204.625C117.899 204.625 120.688 204.01 122.816 202.781C124.944 201.553 126.008 199.943 126.008 198.332V195.65C126.008 194.04 124.944 192.43 122.816 191.201Z",
    fill: "#B5B3AB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M115.317 189.363C112.529 189.271 109.722 189.793 107.554 190.95C105.387 192.108 104.271 193.682 104.217 195.291C104.165 196.901 105.175 198.545 107.261 199.844C109.348 201.141 112.114 201.848 114.902 201.94C117.689 202.032 120.497 201.509 122.665 200.352C124.832 199.194 125.949 197.621 126.001 196.011C126.055 194.402 125.045 192.757 122.959 191.458C120.871 190.161 118.105 189.454 115.317 189.363Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M113.915 96.1762C114.738 96.6516 116.072 96.6516 116.895 96.1762C117.307 95.9391 117.512 95.6273 117.512 95.3167L119.607 195.648C119.607 196.27 119.196 196.889 118.377 197.362C116.735 198.311 114.075 198.311 112.434 197.362C111.614 196.889 111.204 196.27 111.204 195.648L113.298 95.3167C113.298 95.6273 113.504 95.9391 113.915 96.1762Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M113.915 96.1762C114.738 96.6516 116.072 96.6516 116.895 96.1762C117.307 95.9391 117.512 95.6273 117.512 95.3167L119.607 195.648C119.607 196.27 119.196 196.889 118.377 197.362C116.735 198.311 114.075 198.311 112.434 197.362C111.614 196.889 111.204 196.27 111.204 195.648L113.298 95.3167C113.298 95.6273 113.504 95.9391 113.915 96.1762Z",
    fill: "#DAD9D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M113.301 95.3167C113.301 95.6273 113.507 95.9391 113.917 96.1763C114.741 96.6517 116.075 96.6517 116.898 96.1763C117.31 95.9391 117.514 95.6273 117.514 95.3167L117.601 100.222C116.236 100.826 114.319 101.639 113.184 101.967L113.301 95.3167Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M107.49 86.3223V86.3176C107.49 86.3176 113.085 83.97 116.557 83.577C117.857 83.4294 118.823 83.5628 119.517 83.8449L125.414 86.1012C125.417 86.1018 125.421 86.1036 125.423 86.1048L125.536 86.148C125.537 86.1498 125.539 86.1516 125.54 86.154C126.382 86.5174 126.839 87.5168 126.696 88.5543C126.539 89.7067 125.694 91.7768 124.118 93.0181C123.463 93.5339 122.043 94.7415 121.377 95.2448C119.784 96.447 114.461 99.2374 114.461 99.2374L107.074 94.9738V87.0289C107.074 86.6418 107.24 86.3946 107.49 86.3223Z",
    fill: "#DAD9D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M108.102 86.4359L113.432 89.5137C113.997 89.8398 114.461 90.6407 114.461 91.2934V99.2377L107.074 94.9736V87.0293C107.074 86.376 107.536 86.1092 108.102 86.4359Z",
    fill: "#64605E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M123.201 86.8447C124.201 86.4671 124.949 86.2169 125.594 86.1855C125.592 86.1849 125.595 86.1796 125.595 86.1784C126.4 86.5613 126.833 87.5418 126.694 88.555C126.536 89.7074 125.691 91.7769 124.116 93.0183C123.461 93.534 122.04 94.7422 121.374 95.2455C119.782 96.4477 114.458 99.2381 114.458 99.2381V91.6091C115.736 90.8658 121.696 87.4126 123.201 86.8447Z",
    fill: "#DAD9D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M108.24 88.8533C107.232 89.8836 107.547 92.3165 108.943 94.2864C110.34 96.2552 112.289 97.0175 113.296 95.9866C114.304 94.9563 113.989 92.5234 112.594 90.5535C111.196 88.5841 109.247 87.823 108.24 88.8533Z",
    fill: "#010203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M105.327 91.6374L109.19 89.4036C109.624 89.157 110.222 89.1944 110.882 89.575C112.208 90.3409 113.284 92.2041 113.284 93.7353C113.284 94.506 113.011 95.046 112.572 95.295L108.709 97.5281C108.275 97.7736 107.678 97.7356 107.019 97.355C105.692 96.5897 104.618 94.7265 104.618 93.1953C104.618 92.4264 104.889 91.8869 105.327 91.6374Z",
    fill: "#64605E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rotor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FluegelRE"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "testCircle",
    cx: 108.309,
    cy: 93.3805,
    r: 54.9395,
    fill: "#FF0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M107.719 96.983L106.516 96.0108L101.699 101.315L85.2571 143.091L86.1433 143.667L106.796 105.275L106.268 99.8707L107.719 96.983Z",
    fill: "#DAD9D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M111.859 92.4979L111.428 93.9844L118.184 96.3714L163.068 95.36L163.256 94.3193L119.862 90.1396L115.083 92.7173L111.859 92.4979Z",
    fill: "#DAD9D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M106.175 90.5801L107.625 90.0391L105.509 83.1938L77.9081 47.7848L76.9609 48.2549L99.5072 85.5669L104.427 87.8617L106.175 90.5801Z",
    fill: "#DAD9D2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M106.319 87.3801L106.362 87.3617C107.768 86.7143 109.908 87.763 111.503 90.0116C113.338 92.6022 113.752 95.801 112.427 97.1562C112.288 97.299 112.132 97.4093 111.969 97.5006L111.971 97.5053C111.96 97.5095 111.95 97.513 111.941 97.5178C111.807 97.5883 111.667 97.6458 111.52 97.6844C103.848 100.705 99.2332 98.1906 99.2332 98.1906C100.216 90.3186 105.799 87.616 106.319 87.3801Z",
    fill: "#DAD9D2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Schlot"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SchlotMain"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 120",
    cx: 184.378,
    cy: 124.285,
    rx: 19.5111,
    ry: 9.59646,
    fill: "#64605E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.378 135.377C196.007 135.377 205.435 130.74 205.435 125.021C205.435 119.301 196.007 114.664 184.378 114.664C172.748 114.664 163.321 119.301 163.321 125.021C163.321 130.74 172.748 135.377 184.378 135.377ZM184.378 132.465C193.564 132.465 201.011 128.803 201.011 124.285C201.011 119.766 193.564 116.104 184.378 116.104C175.191 116.104 167.745 119.766 167.745 124.285C167.745 128.803 175.191 132.465 184.378 132.465Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SteamMain"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SteamGroup1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 126",
    cx: 174.298,
    cy: 126.599,
    r: 7.20407,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 127",
    cx: 182.288,
    cy: 126.599,
    r: 7.20407,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 128",
    cx: 179.191,
    cy: 119.228,
    r: 5.72357,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 129",
    d: "M184.581 112.756C184.581 115.917 182.019 118.479 178.858 118.479C175.697 118.479 173.134 115.917 173.134 112.756C173.134 109.595 175.697 107.032 178.858 107.032C182.019 107.032 184.581 109.595 184.581 112.756Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 130",
    cx: 180.763,
    cy: 110.399,
    r: 4.98409,
    fill: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SteamGroup2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 136",
    cx: 188.159,
    cy: 110.381,
    r: 4.98409,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 131",
    cx: 185.893,
    cy: 117.489,
    r: 5.72357,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 132",
    cx: 190.737,
    cy: 124.285,
    r: 5.72357,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 133",
    cx: 193.586,
    cy: 117.489,
    r: 5.72357,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 134",
    cx: 189.306,
    cy: 128.157,
    r: 5.72357,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 135",
    cx: 194.308,
    cy: 125.184,
    r: 5.00186,
    fill: "#EEEEEE"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M162.536 157.534C162.758 154.514 163.277 125.493 163.277 125.493L171.188 131.963L184.129 133.942V228.113H143.651C148.64 210.208 159.757 173.489 160.612 169.855C161.467 166.221 162.314 160.554 162.536 157.534Z",
    fill: "#DAD9D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M206.174 157.401C205.952 154.381 205.433 125.36 205.433 125.36L195.573 132.72L181.265 135.222V227.98L225.058 227.98C220.07 210.075 208.953 173.356 208.098 169.722C207.242 166.087 206.396 160.42 206.174 157.401Z",
    fill: "#DAD9D2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 118",
    cx: 184.399,
    cy: 230.833,
    rx: 41.0219,
    ry: 21.6259,
    fill: "#DAD9D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.447 173.219V132.729H178.068V173.267L166.431 248.903L165.818 248.809L177.447 173.219Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.805 173.219V132.729H193.185V173.267L204.821 248.903L205.435 248.809L193.805 173.219Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.156 169.141V128.67H166.777V169.227L147.166 238.565L146.569 238.396L166.156 169.141Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.937 169.372V128.902H202.317V169.461L221.897 236.789L222.493 236.616L202.937 169.372Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 121",
    d: "M184.378 173.405C196.686 173.405 206.749 168.441 206.749 162.388L207.074 164.405C207.074 170.459 196.686 175.091 184.378 175.091C172.069 175.091 161.596 170.951 161.596 164.897L162.014 162.411C162.014 168.465 172.069 173.405 184.378 173.405Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 122",
    d: "M185.215 219.884C203.774 219.884 217.91 209.259 217.91 203.205L218.546 205.491C218.546 211.545 203.774 221.57 185.215 221.57C166.657 221.57 150.036 212.31 150.036 206.256L150.667 203.77C150.667 209.824 166.657 219.884 185.215 219.884Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 123",
    d: "M185.354 251.009C207.448 251.009 224.755 241.404 224.755 226.881C225.199 228.182 225.289 229.044 225.289 229.044C227.182 242.26 207.448 252.695 185.354 252.695C163.259 252.695 141.194 243.118 143.412 228.826L144.13 226.375C142.77 241.216 163.259 251.009 185.354 251.009Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Schatten",
    d: "M206.174 157.401C205.952 154.381 205.433 125.36 205.433 125.36L198.949 130.916L193.24 133.243V174.26L204.968 249.88C204.968 249.88 211.906 247.506 215.222 245.398C218.133 243.547 223.121 239.888 224.839 234.467C225.948 230.967 225.058 227.98 225.058 227.98C220.07 210.075 208.953 173.356 208.097 169.722C207.242 166.088 206.396 160.42 206.174 157.401Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Schatten_2",
    d: "M162.625 157.061C162.847 154.041 163.366 125.021 163.366 125.021L166.778 125.021V169.208L146.841 239.737C145.604 238.23 144.367 236.226 143.741 234.248C142.631 230.748 143.741 227.641 143.741 227.641C148.729 209.736 159.846 173.017 160.701 169.383C161.557 165.748 162.403 160.081 162.625 157.061Z",
    fill: "black",
    fillOpacity: 0.15
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    d: "M184.378 135.377C196.007 135.377 205.435 130.74 205.435 125.021C205.435 123.822 205.021 122.671 204.259 121.6L200.681 122.657C200.897 123.183 201.011 123.727 201.011 124.285C201.011 128.803 193.564 132.465 184.378 132.465C175.191 132.465 167.745 128.803 167.745 124.285C167.745 122.583 168.801 121.002 170.609 119.693L168.106 118.446C165.116 120.235 163.321 122.524 163.321 125.021C163.321 130.74 172.748 135.377 184.378 135.377Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SteamCloud1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 133_2",
    cx: 192.821,
    cy: 93.375,
    r: 5.72357,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 134_2",
    cx: 191.865,
    cy: 101.991,
    r: 5.72357,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 135_2",
    cx: 196.867,
    cy: 99.0176,
    r: 5.00186,
    fill: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SteamCloud2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 133_3",
    cx: 174.111,
    cy: 101.926,
    r: 5.72357,
    transform: "rotate(-130.363 174.111 101.926)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 134_3",
    cx: 179.586,
    cy: 99.1721,
    r: 5.72357,
    transform: "rotate(-130.363 179.586 99.1721)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 135_3",
    cx: 175.79,
    cy: 95.1894,
    r: 5.00186,
    transform: "rotate(-130.363 175.79 95.1894)",
    fill: "#EEEEEE"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "PV"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PV_Schatten",
    d: "M279.564 303.084L268.688 304.25L245.096 290.784L274.375 272.233L303.711 289.103L279.564 303.084Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "PV-Aufbau"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PV-Fu\xC3\x9F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M258.869 294.846C258.869 296.953 255.787 298.662 251.986 298.662C248.185 298.662 245.103 296.953 245.103 294.846C245.103 292.739 248.185 291.031 251.986 291.031C255.787 291.031 258.869 292.739 258.869 294.846Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M258.87 294.724C258.872 294.764 258.875 294.806 258.875 294.847C258.875 296.954 255.793 298.662 251.992 298.662C248.19 298.662 245.109 296.954 245.109 294.847V296.722H245.114C245.218 298.779 248.255 300.429 251.992 300.429C255.793 300.429 258.875 298.721 258.875 296.614V294.724H258.87Z",
    fill: "#E4EDEA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PV-Bein"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M254.331 272.57C254.331 273.11 253.541 273.548 252.567 273.548C251.592 273.548 250.802 273.11 250.802 272.57C250.802 272.03 251.592 271.592 252.567 271.592C253.541 271.592 254.331 272.03 254.331 272.57Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M251.317 273.219C252.006 273.617 253.124 273.617 253.813 273.219C254.157 273.02 254.329 272.759 254.329 272.499L256.114 293.665C256.114 294.186 255.77 294.705 255.084 295.101C253.709 295.895 251.482 295.895 250.108 295.101C249.421 294.705 249.078 294.186 249.078 293.665L250.801 272.499C250.801 272.759 250.973 273.02 251.317 273.219Z",
    fill: "#DAD9D2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PV-Fu\xC3\x9F_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M229.857 278.019C229.857 280.126 226.775 281.834 222.974 281.834C219.172 281.834 216.09 280.126 216.09 278.019C216.09 275.912 219.172 274.204 222.974 274.204C226.775 274.204 229.857 275.912 229.857 278.019Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M229.857 277.896C229.859 277.937 229.863 277.979 229.863 278.019C229.863 280.126 226.781 281.834 222.979 281.834C219.178 281.834 216.097 280.126 216.097 278.019V279.894H216.102C216.206 281.951 219.243 283.601 222.979 283.601C226.781 283.601 229.863 281.893 229.863 279.786V277.896H229.857Z",
    fill: "#E4EDEA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PV-Bein_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M225.455 255.971C225.455 256.511 224.665 256.949 223.69 256.949C222.716 256.949 221.926 256.511 221.926 255.971C221.926 255.431 222.716 254.993 223.69 254.993C224.665 254.993 225.455 255.431 225.455 255.971Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M222.44 256.62C223.13 257.018 224.247 257.018 224.936 256.62C225.281 256.421 225.452 256.16 225.452 255.9L227.237 277.066C227.237 277.587 226.894 278.105 226.207 278.502C224.833 279.296 222.606 279.296 221.231 278.502C220.545 278.105 220.202 277.587 220.202 277.066L221.924 255.9C221.924 256.16 222.096 256.421 222.44 256.62Z",
    fill: "#DAD9D2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "PV_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Reihe-Vorne"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PV-Zelle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M232.743 216.776L264.482 235.213L235.075 284.081L202.366 265.122L232.743 216.776Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M233.175 218.282L262.867 235.693L233.685 281.83L203.984 264.302L233.175 218.282Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M257.621 241.625L252.817 238.823C252.336 238.542 251.668 237.612 252.371 236.633L254.937 232.589C255.218 232.163 256.093 232.008 256.574 232.288L261.667 235.236C262.147 235.516 262.384 236.05 262.228 236.575L259.382 241.061C258.932 241.695 258.102 241.905 257.621 241.625Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M250.172 237.302L245.368 234.5C244.887 234.219 244.219 233.29 244.922 232.31L247.488 228.266C247.769 227.84 248.644 227.685 249.125 227.966L254.218 230.913C254.699 231.194 254.935 231.727 254.779 232.252L251.933 236.739C251.483 237.372 250.653 237.582 250.172 237.302Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M253.349 248.099L248.545 245.297C248.065 245.016 247.397 244.087 248.1 243.107L250.665 239.063C250.946 238.637 251.822 238.482 252.302 238.763L257.396 241.71C257.876 241.991 258.112 242.524 257.956 243.049L255.11 247.536C254.66 248.169 253.83 248.379 253.349 248.099Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M245.872 243.802L241.068 240.999C240.587 240.719 239.92 239.789 240.623 238.809L243.188 234.766C243.469 234.34 244.345 234.185 244.825 234.465L249.918 237.413C250.398 237.693 250.635 238.226 250.479 238.752L247.632 243.238C247.183 243.871 246.352 244.082 245.872 243.802Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M242.728 232.956L237.924 230.154C237.443 229.874 236.775 228.944 237.478 227.965L240.044 223.921C240.325 223.495 241.2 223.34 241.681 223.62L246.774 226.568C247.254 226.848 247.491 227.381 247.335 227.907L244.489 232.393C244.039 233.026 243.208 233.237 242.728 232.956Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M235.278 228.634L230.474 225.831C229.993 225.551 229.325 224.621 230.028 223.641L232.594 219.598C232.875 219.172 233.75 219.017 234.231 219.297L239.324 222.245C239.805 222.525 240.041 223.058 239.885 223.584L237.039 228.07C236.589 228.704 235.759 228.914 235.278 228.634Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M238.452 239.43L233.649 236.628C233.168 236.347 232.5 235.417 233.203 234.438L235.769 230.394C236.049 229.968 236.925 229.813 237.406 230.093L242.499 233.041C242.98 233.321 243.216 233.854 243.059 234.38L240.213 238.867C239.764 239.5 238.933 239.71 238.452 239.43Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M230.977 235.133L226.173 232.331C225.693 232.05 225.024 231.12 225.727 230.141L228.293 226.097C228.574 225.671 229.449 225.516 229.93 225.796L235.023 228.745C235.503 229.024 235.74 229.558 235.584 230.083L232.738 234.57C232.288 235.203 231.458 235.413 230.977 235.133Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M249.193 254.672L244.389 251.87C243.909 251.589 243.241 250.659 243.944 249.68L246.509 245.636C246.79 245.21 247.666 245.055 248.146 245.335L253.24 248.283C253.72 248.563 253.957 249.097 253.8 249.622L250.953 254.109C250.505 254.742 249.673 254.952 249.193 254.672Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M241.741 250.348L236.937 247.546C236.456 247.265 235.789 246.336 236.492 245.356L239.057 241.312C239.338 240.886 240.214 240.731 240.694 241.012L245.787 243.959C246.267 244.24 246.505 244.773 246.348 245.298L243.501 249.785C243.053 250.418 242.221 250.628 241.741 250.348Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M245.034 261.286L240.23 258.484C239.75 258.203 239.081 257.274 239.784 256.294L242.35 252.25C242.631 251.824 243.506 251.669 243.987 251.95L249.08 254.897C249.56 255.178 249.797 255.711 249.641 256.236L246.795 260.723C246.345 261.356 245.515 261.566 245.034 261.286Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M237.534 257.02L232.73 254.218C232.25 253.937 231.581 253.007 232.284 252.028L234.85 247.984C235.131 247.558 236.006 247.403 236.487 247.684L241.58 250.631C242.06 250.911 242.297 251.445 242.141 251.97L239.295 256.457C238.845 257.09 238.015 257.3 237.534 257.02Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M234.299 246.003L229.495 243.2C229.015 242.92 228.347 241.99 229.05 241.011L231.615 236.967C231.896 236.541 232.772 236.386 233.252 236.666L238.346 239.614C238.826 239.894 239.062 240.427 238.906 240.953L236.06 245.439C235.61 246.072 234.78 246.283 234.299 246.003Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M226.847 241.679L222.043 238.877C221.563 238.596 220.895 237.667 221.598 236.687L224.163 232.643C224.444 232.217 225.32 232.062 225.8 232.343L230.893 235.29C231.374 235.571 231.611 236.104 231.455 236.629L228.608 241.116C228.159 241.749 227.328 241.959 226.847 241.679Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M230.026 252.594L225.222 249.792C224.741 249.512 224.073 248.582 224.776 247.602L227.342 243.559C227.623 243.133 228.498 242.978 228.979 243.258L234.072 246.206C234.553 246.486 234.789 247.019 234.632 247.545L231.786 252.031C231.337 252.664 230.506 252.875 230.026 252.594Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M222.544 248.304L217.74 245.502C217.26 245.222 216.592 244.292 217.295 243.313L219.86 239.269C220.141 238.843 221.017 238.688 221.497 238.968L226.59 241.916C227.07 242.196 227.307 242.729 227.151 243.255L224.305 247.741C223.855 248.374 223.024 248.585 222.544 248.304Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M240.977 267.863L236.173 265.061C235.692 264.781 235.024 263.851 235.727 262.872L238.293 258.828C238.574 258.401 239.449 258.247 239.93 258.527L245.023 261.475C245.504 261.755 245.74 262.288 245.583 262.813L242.737 267.3C242.288 267.933 241.457 268.144 240.977 267.863Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M233.529 263.541L228.725 260.738C228.244 260.458 227.577 259.528 228.28 258.548L230.845 254.505C231.126 254.079 232.002 253.924 232.482 254.204L237.576 257.152C238.056 257.432 238.293 257.965 238.136 258.491L235.289 262.978C234.841 263.611 234.009 263.821 233.529 263.541Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M236.705 274.337L231.901 271.535C231.421 271.255 230.753 270.325 231.456 269.346L234.021 265.302C234.302 264.875 235.178 264.721 235.658 265.001L240.752 267.949C241.232 268.229 241.468 268.762 241.312 269.287L238.466 273.774C238.016 274.407 237.186 274.618 236.705 274.337Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M229.23 270.04L224.426 267.238C223.945 266.957 223.277 266.027 223.98 265.048L226.546 261.004C226.827 260.578 227.702 260.423 228.183 260.703L233.276 263.651C233.756 263.931 233.993 264.464 233.837 264.99L230.99 269.477C230.541 270.11 229.71 270.32 229.23 270.04Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M226.083 259.195L221.279 256.392C220.798 256.112 220.13 255.182 220.833 254.202L223.399 250.159C223.68 249.733 224.555 249.578 225.036 249.858L230.129 252.806C230.609 253.086 230.846 253.619 230.69 254.145L227.844 258.632C227.394 259.265 226.564 259.475 226.083 259.195Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M218.634 254.871L213.83 252.069C213.35 251.788 212.682 250.859 213.385 249.879L215.95 245.835C216.231 245.409 217.107 245.254 217.587 245.535L222.681 248.483C223.161 248.763 223.397 249.296 223.241 249.821L220.395 254.308C219.945 254.942 219.115 255.151 218.634 254.871Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M221.812 265.668L217.008 262.866C216.528 262.586 215.86 261.656 216.563 260.677L219.128 256.633C219.409 256.206 220.285 256.052 220.765 256.332L225.859 259.28C226.339 259.56 226.576 260.093 226.42 260.618L223.573 265.105C223.124 265.738 222.293 265.949 221.812 265.668Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M214.331 261.371L209.527 258.569C209.047 258.288 208.379 257.359 209.082 256.379L211.647 252.335C211.928 251.909 212.804 251.754 213.284 252.035L218.377 254.982C218.858 255.263 219.095 255.796 218.938 256.321L216.092 260.808C215.643 261.441 214.812 261.651 214.331 261.371Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M232.417 280.874L227.613 278.071C227.132 277.791 226.464 276.861 227.167 275.882L229.733 271.838C230.014 271.412 230.889 271.257 231.37 271.537L236.463 274.485C236.944 274.765 237.18 275.298 237.023 275.824L234.177 280.31C233.728 280.944 232.897 281.154 232.417 280.874Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M224.94 276.576L220.136 273.773C219.656 273.493 218.987 272.563 219.69 271.584L222.256 267.54C222.537 267.114 223.412 266.959 223.893 267.239L228.986 270.187C229.466 270.467 229.703 271 229.547 271.526L226.701 276.012C226.251 276.645 225.421 276.856 224.94 276.576Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M217.522 272.205L212.718 269.402C212.238 269.122 211.57 268.192 212.273 267.212L214.838 263.169C215.119 262.743 215.995 262.588 216.475 262.868L221.569 265.816C222.049 266.096 222.286 266.629 222.13 267.155L219.283 271.641C218.834 272.275 218.003 272.485 217.522 272.205Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M210.041 267.907L205.237 265.104C204.757 264.824 204.089 263.894 204.792 262.915L207.357 258.871C207.638 258.445 208.514 258.29 208.994 258.57L214.087 261.518C214.567 261.798 214.804 262.331 214.647 262.857L211.801 267.343C211.352 267.976 210.521 268.187 210.041 267.907Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M235.482 219.842L206.872 265.963L235.482 219.842Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M235.482 219.842L206.872 265.963L235.482 219.842Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M237.35 220.992L208.74 267.113L237.35 220.992Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M237.35 220.992L208.74 267.113L237.35 220.992Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M242.836 224.235L214.226 270.356L242.836 224.235Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M242.836 224.235L214.226 270.356L242.836 224.235Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M244.7 225.386L216.09 271.507L244.7 225.386Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M244.7 225.386L216.09 271.507L244.7 225.386Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M250.187 228.525L221.577 274.646L250.187 228.525Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M250.187 228.525L221.577 274.646L250.187 228.525Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M252.052 229.675L223.442 275.796L252.052 229.675Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M252.052 229.675L223.442 275.796L252.052 229.675Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M257.538 232.815L228.928 278.935L257.538 232.815Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M257.538 232.815L228.928 278.935L257.538 232.815Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M259.4 233.965L230.791 280.086L259.4 233.965Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M259.4 233.965L230.791 280.086L259.4 233.965Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M233.126 218.133L232.97 218.216L262.872 235.693L263.014 235.609L233.126 218.133Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M232.972 218.215L232.922 218.387L262.681 235.724L262.707 235.611L232.972 218.215Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M262.87 235.691L263.013 235.609L234.002 281.906L233.687 282.097L262.87 235.691Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M262.868 235.691L262.73 235.61L233.558 282.021L233.686 282.097L262.868 235.691Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M233.125 218.504L233.248 218.577L203.934 264.492L203.748 264.563L233.125 218.504Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M233.177 218.333L232.971 218.213L203.517 264.43L203.747 264.564L233.177 218.333Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M203.994 264.301L203.811 264.351L233.602 281.877L233.64 281.758L203.994 264.301Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M203.813 264.351L203.748 264.563L233.559 282.022L233.604 281.877L203.813 264.351Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M264.484 235.21L265.562 236.692L236.163 285.552L235.077 284.08L264.484 235.21Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M235.084 284.07L236.162 285.551L203.846 266.704L202.367 265.122L235.084 284.07Z",
    fill: "#F8F8F9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PV-Zelle_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M265.454 235.475L297.193 253.912L267.786 302.779L235.077 283.82L265.454 235.475Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M265.885 236.98L295.579 254.391L266.397 300.528L236.695 283.001L265.885 236.98Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M290.333 260.324L285.529 257.522C285.048 257.241 284.38 256.311 285.083 255.332L287.649 251.288C287.93 250.862 288.805 250.707 289.286 250.987L294.379 253.935C294.859 254.215 295.096 254.748 294.94 255.274L292.094 259.761C291.644 260.394 290.814 260.604 290.333 260.324Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M282.877 256.001L278.073 253.198C277.593 252.918 276.925 251.988 277.628 251.008L280.193 246.965C280.474 246.539 281.35 246.384 281.83 246.664L286.923 249.612C287.404 249.892 287.641 250.425 287.485 250.951L284.638 255.438C284.189 256.071 283.358 256.281 282.877 256.001Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M286.059 266.797L281.255 263.995C280.774 263.715 280.106 262.785 280.809 261.806L283.375 257.762C283.656 257.335 284.531 257.181 285.012 257.461L290.105 260.409C290.585 260.689 290.822 261.222 290.666 261.747L287.82 266.234C287.37 266.867 286.54 267.078 286.059 266.797Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M278.578 262.5L273.774 259.698C273.293 259.417 272.625 258.487 273.328 257.508L275.894 253.464C276.175 253.038 277.05 252.883 277.531 253.163L282.624 256.111C283.105 256.391 283.341 256.925 283.185 257.45L280.339 261.937C279.889 262.57 279.059 262.78 278.578 262.5Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M275.438 251.655L270.634 248.852C270.153 248.572 269.485 247.642 270.188 246.663L272.754 242.619C273.035 242.193 273.91 242.038 274.391 242.318L279.484 245.266C279.965 245.546 280.201 246.079 280.044 246.605L277.198 251.092C276.749 251.725 275.918 251.935 275.438 251.655Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M267.985 247.331L263.181 244.53C262.7 244.249 262.033 243.319 262.736 242.34L265.301 238.296C265.582 237.869 266.458 237.715 266.938 237.995L272.031 240.943C272.512 241.223 272.749 241.756 272.592 242.281L269.745 246.768C269.297 247.402 268.466 247.612 267.985 247.331Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M271.163 258.129L266.359 255.326C265.879 255.046 265.211 254.116 265.914 253.137L268.479 249.093C268.76 248.667 269.636 248.512 270.116 248.792L275.21 251.74C275.69 252.02 275.927 252.553 275.771 253.079L272.924 257.565C272.475 258.198 271.644 258.409 271.163 258.129Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M263.682 253.831L258.879 251.03C258.398 250.749 257.73 249.819 258.433 248.84L260.999 244.796C261.279 244.369 262.155 244.215 262.635 244.495L267.729 247.443C268.21 247.723 268.446 248.256 268.289 248.781L265.443 253.268C264.994 253.901 264.163 254.112 263.682 253.831Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M281.902 273.37L277.098 270.568C276.617 270.288 275.949 269.358 276.652 268.379L279.218 264.334C279.499 263.908 280.375 263.753 280.855 264.034L285.948 266.981C286.429 267.262 286.665 267.795 286.508 268.32L283.663 272.807C283.213 273.44 282.383 273.65 281.902 273.37Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M274.45 269.047L269.646 266.244C269.166 265.964 268.498 265.034 269.201 264.054L271.766 260.011C272.047 259.585 272.923 259.43 273.403 259.71L278.496 262.658C278.977 262.938 279.214 263.471 279.058 263.997L276.211 268.483C275.762 269.117 274.931 269.327 274.45 269.047Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M277.741 279.984L272.937 277.182C272.456 276.902 271.788 275.972 272.492 274.993L275.057 270.949C275.338 270.522 276.214 270.368 276.694 270.648L281.788 273.596C282.268 273.876 282.505 274.409 282.348 274.934L279.502 279.421C279.053 280.054 278.222 280.265 277.741 279.984Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M270.247 275.718L265.443 272.916C264.962 272.636 264.295 271.706 264.998 270.726L267.563 266.683C267.844 266.256 268.72 266.102 269.2 266.382L274.293 269.33C274.773 269.61 275.011 270.143 274.854 270.668L272.007 275.155C271.559 275.788 270.727 275.999 270.247 275.718Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M267.003 264.701L262.2 261.899C261.719 261.618 261.051 260.688 261.754 259.709L264.32 255.665C264.601 255.239 265.476 255.084 265.957 255.364L271.05 258.312C271.53 258.592 271.767 259.126 271.61 259.651L268.764 264.138C268.315 264.771 267.484 264.981 267.003 264.701Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M259.552 260.377L254.748 257.576C254.268 257.295 253.6 256.365 254.303 255.386L256.868 251.342C257.149 250.915 258.025 250.761 258.505 251.042L263.599 253.989C264.079 254.27 264.315 254.803 264.159 255.327L261.313 259.814C260.863 260.448 260.032 260.658 259.552 260.377Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M262.731 271.293L257.927 268.491C257.447 268.21 256.779 267.28 257.482 266.301L260.047 262.257C260.328 261.831 261.204 261.676 261.684 261.956L266.777 264.904C267.257 265.184 267.494 265.718 267.338 266.243L264.492 270.73C264.042 271.363 263.212 271.573 262.731 271.293Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M255.251 267.002L250.447 264.2C249.967 263.92 249.299 262.99 250.002 262.01L252.567 257.966C252.848 257.54 253.724 257.385 254.204 257.666L259.298 260.613C259.779 260.894 260.015 261.427 259.859 261.952L257.012 266.439C256.563 267.072 255.732 267.282 255.251 267.002Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M273.689 286.562L268.885 283.76C268.405 283.479 267.736 282.55 268.439 281.57L271.005 277.526C271.286 277.1 272.161 276.945 272.642 277.226L277.735 280.173C278.215 280.454 278.452 280.987 278.296 281.512L275.45 285.999C275 286.632 274.17 286.842 273.689 286.562Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M266.235 282.239L261.431 279.437C260.951 279.156 260.283 278.226 260.986 277.247L263.551 273.203C263.832 272.777 264.708 272.622 265.188 272.902L270.281 275.851C270.761 276.13 270.998 276.664 270.842 277.189L267.996 281.676C267.546 282.309 266.716 282.519 266.235 282.239Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M269.417 293.036L264.613 290.234C264.133 289.953 263.465 289.023 264.168 288.044L266.733 284C267.014 283.574 267.89 283.419 268.37 283.699L273.463 286.647C273.944 286.927 274.181 287.461 274.024 287.986L271.177 292.473C270.729 293.106 269.898 293.316 269.417 293.036Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M261.935 288.738L257.131 285.936C256.651 285.656 255.983 284.726 256.686 283.747L259.251 279.703C259.532 279.276 260.408 279.122 260.888 279.402L265.982 282.35C266.462 282.63 266.699 283.163 266.542 283.688L263.696 288.175C263.246 288.808 262.416 289.019 261.935 288.738Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M258.791 277.893L253.987 275.091C253.506 274.81 252.839 273.88 253.542 272.901L256.107 268.857C256.388 268.431 257.264 268.276 257.744 268.557L262.837 271.504C263.317 271.784 263.554 272.318 263.397 272.843L260.551 277.329C260.102 277.962 259.271 278.173 258.791 277.893Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M251.34 273.57L246.536 270.768C246.055 270.487 245.387 269.557 246.09 268.578L248.656 264.534C248.937 264.108 249.812 263.953 250.293 264.233L255.386 267.181C255.866 267.461 256.103 267.994 255.946 268.52L253.1 273.007C252.651 273.64 251.82 273.85 251.34 273.57Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M254.522 284.367L249.718 281.565C249.237 281.284 248.569 280.354 249.272 279.375L251.838 275.331C252.119 274.905 252.994 274.75 253.475 275.031L258.568 277.979C259.048 278.259 259.285 278.792 259.129 279.317L256.283 283.804C255.833 284.437 255.003 284.647 254.522 284.367Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M247.04 280.07L242.236 277.267C241.755 276.987 241.087 276.057 241.79 275.077L244.356 271.034C244.637 270.608 245.512 270.453 245.993 270.733L251.086 273.681C251.567 273.961 251.803 274.494 251.647 275.02L248.801 279.507C248.351 280.14 247.52 280.35 247.04 280.07Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M265.126 299.572L260.322 296.77C259.842 296.489 259.174 295.559 259.877 294.58L262.442 290.536C262.723 290.11 263.599 289.955 264.079 290.236L269.172 293.184C269.652 293.464 269.89 293.997 269.733 294.522L266.887 299.009C266.438 299.642 265.607 299.852 265.126 299.572Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M257.645 295.274L252.841 292.472C252.36 292.191 251.693 291.262 252.396 290.282L254.961 286.238C255.242 285.812 256.118 285.657 256.598 285.938L261.692 288.885C262.172 289.166 262.409 289.699 262.252 290.224L259.406 294.711C258.957 295.344 258.126 295.554 257.645 295.274Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M250.232 290.902L245.428 288.101C244.948 287.82 244.279 286.89 244.982 285.911L247.548 281.867C247.829 281.44 248.704 281.286 249.185 281.566L254.278 284.514C254.758 284.794 254.995 285.328 254.838 285.852L251.992 290.339C251.543 290.972 250.712 291.183 250.232 290.902Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M242.749 286.605L237.945 283.803C237.465 283.522 236.797 282.593 237.5 281.613L240.065 277.569C240.346 277.143 241.222 276.988 241.702 277.269L246.796 280.216C247.276 280.497 247.513 281.03 247.356 281.555L244.51 286.042C244.061 286.675 243.23 286.885 242.749 286.605Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M268.194 238.54L239.585 284.661L268.194 238.54Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M268.194 238.54L239.585 284.661L268.194 238.54Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M270.056 239.691L241.446 285.811L270.056 239.691Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M270.056 239.691L241.446 285.811L270.056 239.691Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M275.546 242.933L246.936 289.054L275.546 242.933Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M275.546 242.933L246.936 289.054L275.546 242.933Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M277.408 244.085L248.798 290.205L277.408 244.085Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M277.408 244.085L248.798 290.205L277.408 244.085Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M282.897 247.223L254.287 293.344L282.897 247.223Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    d: "M282.897 247.223L254.287 293.344L282.897 247.223Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M284.76 248.373L256.15 294.494L284.76 248.373Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M284.76 248.373L256.15 294.494L284.76 248.373Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M290.249 251.513L261.639 297.634L290.249 251.513Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M290.249 251.513L261.639 297.634L290.249 251.513Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M292.113 252.663L263.503 298.784L292.113 252.663Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M292.113 252.663L263.503 298.784L292.113 252.663Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M265.836 236.831L265.679 236.914L295.581 254.391L295.724 254.307L265.836 236.831Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M265.677 236.913L265.627 237.085L295.387 254.423L295.413 254.309L265.677 236.913Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M295.58 254.39L295.723 254.307L266.712 300.605L266.397 300.795L295.58 254.39Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M295.581 254.389L295.443 254.309L266.27 300.72L266.398 300.795L295.581 254.389Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M265.838 237.203L265.961 237.275L236.647 283.191L236.46 283.262L265.838 237.203Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M265.886 237.031L265.68 236.911L236.227 283.127L236.456 283.262L265.886 237.031Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M236.705 282.999L236.522 283.049L266.313 300.575L266.351 300.456L236.705 282.999Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M236.526 283.049L236.46 283.261L266.272 300.72L266.317 300.575L236.526 283.049Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M297.189 253.908L298.266 255.39L268.868 304.25L267.782 302.778L297.189 253.908Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M267.795 302.768L268.873 304.25L236.558 285.402L235.077 283.82L267.795 302.768Z",
    fill: "#F8F8F9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99",
    cx: 234.306,
    cy: 264.62,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98",
    cx: 234.306,
    cy: 264.62,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M234.297 256.608L234.919 262.993H233.694L234.297 256.608Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2",
    d: "M234.297 272.57L234.919 266.185H233.694L234.297 272.57Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3",
    d: "M226.468 264.61L232.853 265.233L232.853 264.007L226.468 264.61Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4",
    d: "M242.27 264.61L235.884 265.233L235.884 264.007L242.27 264.61Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_2",
    cx: 267.024,
    cy: 271.129,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_2",
    cx: 267.024,
    cy: 271.129,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_2",
    d: "M267.015 263.117L267.637 269.502H266.412L267.015 263.117Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_2",
    d: "M267.015 279.079L267.637 272.694H266.412L267.015 279.079Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_2",
    d: "M259.186 271.119L265.571 271.742L265.571 270.516L259.186 271.119Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_2",
    d: "M274.988 271.119L268.602 271.742L268.602 270.516L274.988 271.119Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_3",
    cx: 232.563,
    cy: 235.639,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_3",
    cx: 232.563,
    cy: 235.639,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_3",
    d: "M232.554 227.627L233.176 234.013H231.951L232.554 227.627Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_3",
    d: "M232.554 243.59L233.176 237.205H231.951L232.554 243.59Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_3",
    d: "M224.725 235.63L231.11 236.252L231.11 235.027L224.725 235.63Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_3",
    d: "M240.527 235.63L234.142 236.252L234.142 235.027L240.527 235.63Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_4",
    cx: 264.018,
    cy: 243.635,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_4",
    cx: 264.018,
    cy: 243.635,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_4",
    d: "M264.008 235.623L264.631 242.008H263.405L264.008 235.623Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_4",
    d: "M264.008 251.586L264.631 245.201H263.405L264.008 251.586Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_4",
    d: "M256.179 243.626L262.564 244.248L262.564 243.023L256.179 243.626Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_4",
    d: "M271.981 243.626L265.596 244.248L265.596 243.023L271.981 243.626Z",
    fill: "white",
    fillOpacity: 0.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Baum"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M410.003 220.146C416.058 223.525 416.058 229.099 410.003 232.622C403.182 236.073 395.113 236.073 388.294 232.622C382.24 229.245 382.24 223.67 388.294 220.146C395.113 216.696 403.182 216.696 410.003 220.146Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M397.954 226.818L394.516 206.154C394.598 206.997 394.178 207.639 393.254 208.22C391.505 209.32 388.605 209.472 386.777 208.506C385.828 208.006 385.356 207.345 385.366 206.652L385.363 206.652L383.291 228.214C383.183 229.429 383.952 230.629 385.588 231.494C388.573 233.071 393.311 232.871 396.168 231.074C398.078 229.873 398.663 228.231 397.954 226.818Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M382.083 167.041C391.644 167.041 399.395 175.035 399.395 184.895C399.395 194.755 391.644 202.749 382.083 202.749C372.521 202.749 364.77 194.755 364.77 184.895C364.77 175.035 372.521 167.041 382.083 167.041Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    d: "M391.857 180.763C386.158 183.886 376.926 183.886 371.228 180.763C368.631 179.376 367.26 177.502 366.972 175.698C366.683 177.988 368.054 180.277 371.228 182.012C376.926 185.135 386.158 185.135 391.857 182.012C394.959 180.277 396.402 177.987 396.113 175.698C395.824 177.571 394.455 179.373 391.857 180.763Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    d: "M393.385 193.299C386.842 196.812 376.242 196.812 369.7 193.299C366.718 191.738 365.144 189.63 364.813 187.6C364.481 190.177 366.056 192.752 369.7 194.704C376.242 198.217 386.842 198.217 393.385 194.704C396.947 192.752 398.603 190.176 398.272 187.6C397.94 189.708 396.368 191.735 393.385 193.299Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    d: "M397.232 175.698C406.793 175.698 414.544 183.691 414.544 193.551C414.544 203.411 406.793 211.405 397.232 211.405C387.67 211.405 379.919 203.411 379.919 193.551C379.919 183.691 387.67 175.698 397.232 175.698Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    d: "M407.929 189.42C402.019 192.542 392.445 192.542 386.536 189.42C383.842 188.032 382.421 186.159 382.122 184.354C381.822 186.645 383.244 188.933 386.536 190.668C392.445 193.791 402.019 193.791 407.929 190.668C411.146 188.933 412.642 186.643 412.343 184.354C412.043 186.227 410.623 188.029 407.929 189.42Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    d: "M409.616 201.956C403.073 205.468 392.473 205.468 385.93 201.956C382.949 200.394 381.375 198.287 381.044 196.256C380.712 198.833 382.286 201.408 385.93 203.36C392.473 206.873 403.073 206.873 409.616 203.36C413.178 201.408 414.834 198.832 414.503 196.256C414.171 198.364 412.599 200.391 409.616 201.956Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    d: "M382.083 190.846C388.656 190.846 393.986 196.418 393.986 203.29C393.986 210.162 388.656 215.733 382.083 215.733C375.509 215.733 370.181 210.162 370.181 203.29C370.181 196.418 375.509 190.846 382.083 190.846Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    d: "M388.801 201.138C384.791 203.48 378.294 203.48 374.284 201.138C372.456 200.097 371.492 198.692 371.289 197.339C371.086 199.056 372.05 200.773 374.284 202.074C378.294 204.416 384.791 204.416 388.801 202.074C390.984 200.773 391.999 199.056 391.796 197.339C391.592 198.744 390.629 200.095 388.801 201.138Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    d: "M390.488 209.794C385.845 212.136 378.322 212.136 373.679 209.794C371.563 208.754 370.446 207.349 370.211 205.995C369.976 207.713 371.093 209.43 373.679 210.731C378.322 213.073 385.845 213.073 390.488 210.731C393.016 209.43 394.191 207.712 393.956 205.995C393.721 207.4 392.605 208.751 390.488 209.794Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Busch klein"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    d: "M82.335 205.08C87.9435 208.228 87.9435 213.423 82.335 216.707C76.0174 219.922 68.5432 219.922 62.2268 216.707C56.6195 213.559 56.6195 208.364 62.2268 205.08C68.5432 201.865 76.0174 201.865 82.335 205.08Z",
    fill: "#5B703A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    d: "M68.3815 175.53C78.8074 175.53 87.259 184.35 87.259 195.229C87.259 206.108 78.8074 214.928 68.3815 214.928C57.9544 214.928 49.504 206.108 49.504 195.229C49.504 184.35 57.9544 175.53 68.3815 175.53Z",
    fill: "#619640"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    d: "M81.9207 203.572C73.4865 207.811 63.5418 207.811 55.1087 203.572C51.2733 201.382 49.5025 198.511 49.5025 195.637C49.2053 199.645 51.3682 203.433 54.9722 205.212C63.4053 209.452 73.3489 209.452 81.7831 205.212C84.9025 203.448 86.9891 200.294 87.3916 196.732C86.6826 199.715 84.6747 202.224 81.9207 203.572Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    d: "M80.0022 191.397C72.6911 195.092 64.0591 195.092 56.748 191.397C54.2983 190.25 52.5263 188.022 51.9595 185.378C51.5478 187.977 53.1914 190.704 56.748 192.766C64.0591 196.46 72.6911 196.46 80.0022 192.766C83.5577 190.713 85.0625 187.977 84.7895 185.378C84.2609 188.041 82.4774 190.282 80.0022 191.397Z",
    fill: "#D9D9D0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Busch klein_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    d: "M56.2133 217.627C59.7084 219.589 59.7084 222.826 56.2133 224.872C52.2764 226.876 47.6188 226.876 43.6826 224.872C40.1882 222.911 40.1882 219.673 43.6826 217.627C47.6188 215.623 52.2764 215.623 56.2133 217.627Z",
    fill: "#5B703A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    d: "M47.5155 199.213C54.0126 199.213 59.2793 204.709 59.2793 211.488C59.2793 218.268 54.0126 223.764 47.5155 223.764C41.0177 223.764 35.7516 218.268 35.7516 211.488C35.7516 204.709 41.0177 199.213 47.5155 199.213Z",
    fill: "#619640"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    d: "M55.9556 216.689C50.6997 219.33 44.5025 219.33 39.2472 216.689C36.8571 215.324 35.7536 213.535 35.7536 211.744C35.5684 214.242 36.9162 216.602 39.1622 217.711C44.4174 220.353 50.6139 220.353 55.8699 217.711C57.8138 216.612 59.1141 214.646 59.3649 212.426C58.9231 214.285 57.6718 215.849 55.9556 216.689Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    d: "M54.7597 209.102C50.2037 211.404 44.8245 211.404 40.2685 209.102C38.7419 208.387 37.6376 206.998 37.2844 205.351C37.0278 206.97 38.0521 208.67 40.2685 209.954C44.8245 212.256 50.2037 212.256 54.7597 209.954C56.9754 208.675 57.9132 206.97 57.7431 205.351C57.4137 207.01 56.3022 208.407 54.7597 209.102Z",
    fill: "#D9D9D0"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1736_803",
    x1: 221.262,
    y1: 109.437,
    x2: 203.114,
    y2: 102.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3839",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1736_803",
    x1: 308.525,
    y1: 166.499,
    x2: 329.753,
    y2: 144.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1736_803",
    x1: 257.195,
    y1: 64.6046,
    x2: 247.415,
    y2: 59.8002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3839",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1736_803",
    x1: 306.91,
    y1: 84.9815,
    x2: 327.318,
    y2: 96.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3839",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1736_803",
    x1: 252.69,
    y1: 124.123,
    x2: 280.714,
    y2: 136.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3839",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedispatch2);
export default __webpack_public_path__ + "static/media/Redispatch2.348333a9c637d8eca2505cee9aca08c0.svg";
export { ForwardRef as ReactComponent };